// PREVIOUS / NEXT BETWEEN A LIST'S RECORDS — a list remembers the order it was showing (after its search and filters)
// when a record is opened from it, and the record's page offers the records either side. One small helper for any
// list → detail pair; the Hotels list → hotel page is the first.
//
// sessionStorage: per browser tab, gone when the tab closes — a convenience, never a source of truth. Every access is
// guarded: storage can be unavailable (private windows, blocked site data), and then the buttons simply do not show.

const keyOf = (list) => `listNav:${list}`;

/** Remember `items` ([{ id, label }], in the order shown) for the `list` named. */
export const saveListNav = (list, items) => {
  try {
    sessionStorage.setItem(keyOf(list), JSON.stringify((items || []).map(i => ({ id: String(i.id), label: i.label || '' }))));
  } catch (e) { /* storage unavailable — no previous / next */ }
};

/**
 * The records either side of `id` in the remembered `list`: { prev, next, index, total } — prev / next are { id, label }
 * or null; null altogether when the list is not remembered or does not hold `id`.
 */
export const listNeighbours = (list, id) => {
  let items;
  try { items = JSON.parse(sessionStorage.getItem(keyOf(list)) || 'null'); } catch (e) { items = null; }
  if (!Array.isArray(items)) return null;
  const index = items.findIndex(i => i.id === String(id));
  if (index < 0) return null;
  return { prev: items[index - 1] || null, next: items[index + 1] || null, index, total: items.length };
};
